export const EmptyText: React.FC = () => {
    return <>-</>;
};
